import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './HowToDonate.css';

const HowToDonate: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const steps = [
    {
      number: '1',
      title: t('howToDonate.steps.step1.title'),
      description: t('howToDonate.steps.step1.description')
    },
    {
      number: '2',
      title: t('howToDonate.steps.step2.title'),
      description: t('howToDonate.steps.step2.description')
    },
    {
      number: '3',
      title: t('howToDonate.steps.step3.title'),
      description: t('howToDonate.steps.step3.description')
    },
    {
      number: '4',
      title: t('howToDonate.steps.step4.title'),
      description: t('howToDonate.steps.step4.description')
    }
  ];

  return (
    <div className="how-to-donate-page">
      <div className="how-to-donate-hero">
        <div className="container">
          <h1 className="page-title">{t('howToDonate.title')}</h1>
        </div>
      </div>

      <section className="how-to-donate-section">
        <div className="container">
          <p className="how-to-donate-intro">{t('howToDonate.intro')}</p>
          
          <div className="donation-steps">
            {steps.map((step, index) => (
              <div key={index} className="donation-step">
                <div className="step-number">{step.number}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="donation-methods">
            <h2>{t('howToDonate.methods.title')}</h2>
            <div className="methods-grid">
              <div className="method-card">
                <h3>{t('howToDonate.methods.online.title')}</h3>
                <p>{t('howToDonate.methods.online.description')}</p>
              </div>
              <div className="method-card">
                <h3>{t('howToDonate.methods.bank.title')}</h3>
                <p>{t('howToDonate.methods.bank.description')}</p>
              </div>
              <div className="method-card">
                <h3>{t('howToDonate.methods.check.title')}</h3>
                <p>{t('howToDonate.methods.check.description')}</p>
              </div>
            </div>
          </div>

          <div className="donate-cta">
            <h2>{t('howToDonate.cta.title')}</h2>
            <button className="donate-now-btn" onClick={() => navigate('/donate-anonymously')}>
              {t('howToDonate.cta.button')}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowToDonate;


